import React, { Component } from 'react'
// import MainMicrosoftOfficeExcel2010 from './main_microsoft_office_excel_2010'
import { Helmet } from 'react-helmet'
// import { Link } from 'react-router-dom';
import DictsInfo from '../../components/dicts_info.jsx'

// function refreshPage(){
//     setTimeout(()=>{
//       window.location.reload(false);
//     }, 500);
   
//   }


export default class CaraMelakukanPengaturanPadaBarisPadaMsOfficeExcel2010 extends Component {
  render() {
    return (
      <div>

      <Helmet>
        <title>Cara Melakukan Pengaturan Pada Baris Pada Microsoft Office Excel 2010</title>
        <meta name="description" content="belajar Microsoft Office Excel 2010, tutorial Microsoft Office Excel 2010, tutorial Microsoft Excel 2010 untuk pemula, berapa bagian Microsoft Excel"/>
      </Helmet>
      
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">

              {/* <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInBottom"> */}
              <div className="col-md-9 col-md-offset-0 col-md-pull-0" >

              {/* <br/>
              <br/> */}
                  
                  
                <h1 style={{fontSize: '1.5rem'}} className="colorlib-heading">Cara Melakukan Pengaturan Pada Baris Pada Microsoft Office Excel 2010</h1>

                <h2>Cara mengatur tinggi baris pada microsoft office excel 2010</h2>
                <p>Caranya adalah:</p>

                <div className= "w3-container" > 
                    <ol> 
                        <li>Pilih baris yang akan dirubah tingginya.</li>
                        <li>Selanjutnya arahkan pointer mouse ke arah batas bawah pada nomor baris. setelah mouse berubah menjadi tanda + dengan arah panah atas dan bawah. Lakukan draging ke atas atau ke bawah untuk menambah atau mengurangi tinggi baris.</li> 
                        <li>Untuk mengembalikan sesuai ukuran standard tinggi baris, lakukan double klik pada batas bawah nomor baris tersebut. </li>                      
                    </ol> 
                </div>
                <br/>

                

                <h2>Cara menyisipkan baris pada microsoft office excel 2010</h2>
                <p>Caranya adalah:</p>

                <div className= "w3-container" > 
                    <ol> 
                        <li>Pilih satu atau beberapa baris sesuai dengan baris yang akan di sisipkan</li> 
                        <li>setelah itu lakukan salah satu dari perintah berikut.
                            <div className= "w3-container" > 
                                <ul>                                 
                                    <li>Klik kanan pada nomor baris terpilih lalu pilih <b>Insert</b></li> 
                                    <li>Klik tab <b>Home&rarr;Insert</b>, pada drop down <b>Insert</b> pilih <b>Insert Sheet Rows</b></li> 
                                </ul> 
                            </div>                        
                        </li>                       
                    </ol> 
                </div>
                <br/>

                <h2>Cara menyembunyikan baris pada microsoft office excel 2010</h2>
                <p>Caranya adalah:</p>
                <div className= "w3-container" > 
                    <ol> 
                        <li>Pilih pada nomor baris yang akan disembunyikan</li> 
                        <li>Klik kanan lalu pilih <b>Hide</b></li> 
                        <li>Maka baris tsb akan disembunyikan.</li> 
                        <li>Dan untuk menampilkan kembali baris yang telah disembunyikan pada microsoft office excel 2010, seleksi bagian sebelum dan sesudah baris yang telah di sembunyikan. Misal baris yang di sembunyikan adalah baris ke 5, maka seleksi dari baris 4 hingga 6. Lalu klik kanan dan pilih <b>Unhide</b>.</li>
                    </ol> 
                </div>
                <br/>

                <h2>Cara menghapus baris pada microsoft office excel 2010</h2>
                <p>Caranya adalah:</p>
                <div className= "w3-container" > 
                    <ol> 
                        <li>Pilih pada nomor baris yang akan dihapus.</li> 
                        <li>Klik kanan lalu pilih <b>Delete</b></li> 
                        <li>Maka baris tsb akan dihapus.</li> 
                    </ol> 
                </div>


                <br/>
                <p><b>Semoga Bermanfaat..</b></p>
               
              </div>
              <DictsInfo/>
            </div>

            {/* <div className="row row-pt-md"></div> */}

          </div>
        </section>
        {/* <MainMicrosoftOfficeExcel2010/> */}
      </div>
    )
  }
}
